import {Injectable} from '@angular/core';
import {QuestListItem} from "../interfaces/quest-list-item";
import {QuestListItemTag} from "../interfaces/quest-list-item-tag";
import {QuestState} from "../enums/quest-state";
import {OverlayService} from "../overlay/overlay.service";
import {QuestsListComponent} from "../shared/quests-list/quests-list.component";
import {AlertLargeFooterComponent} from "../shared/alert-large/alert-large-footer/alert-large-footer.component";
import {Router} from "@angular/router";
import {TargetGroup} from "../enums/target-group";
import {LargeMessageService} from "./large-message.service";
import {LargeMessageTheme} from "../enums/large-message-theme";
import {DataService} from "./data.service";
import {Observable, Subject, take} from "rxjs";
import {GamesService} from "./games.service";
import {EGame} from "../enums/game";
import {Store} from "@ngrx/store";
import {AppState} from "../store";
import {getActiveClassId} from "../store/selectors/teacher.selector";
import {InterestFieldsService} from "./interest-fields.service";
import {TrophyRepositoryService} from "./trophy-repository.service";

@Injectable({
  providedIn: 'root'
})
export class QuestsHelperService {

  private _onQuestDone = new Subject<void>();
  private readonly _QUEST_MESSAGE_STORAGE_KEY = "quest_teacher_message_shown";


  constructor(private overlayService: OverlayService, private router: Router,
              private largeMessageService: LargeMessageService, private data: DataService,
              private gameService: GamesService, private store: Store<AppState>,
              private trophyRepositoryService: TrophyRepositoryService,
              private interestFieldsService: InterestFieldsService) { }

  backendQuestResponseToQuestItems(data: any, targetGroup: TargetGroup): QuestListItem[] {
    // console.log(data);
    const quests: QuestListItem[] = [];
    const rawQuests = data.questTasks ?? [];

    rawQuests.forEach((quest: any) => {
      const tags: QuestListItemTag[] = [];

      quest.questTask.links.forEach((link: any) => {
        tags.push({
          id: link.linkValue ?? "",
          title: link.linkName ?? "",
          isClickable: true,
          onClickCallback: () => {
            this.overlayService.removeLastComponent();

            if(link.linkType === "URL") {
                window.open(link.linkValue, '_blank');
            }

            if(link.linkType === "MAGICLINK") {
              switch(link.linkValue) {
                case "GAMECTP":
                  this.gameService.startGameSetup(EGame.CLICK_THE_PIC);
                  break;
                case "GAMEQUIZ":
                  this.gameService.startGameSetup(EGame.QUIZ);
                  break;
                case "GAMEREQUIREMENTS":
                  this.store.select(getActiveClassId()).pipe(take(1)).subscribe((response) => {
                    const url = this.router.serializeUrl(
                      this.router.createUrlTree(['/lehrer/anforderungen-spiel/' + response])
                    );
                    window.open(url, '_blank');
                  })

                  break;
                case "GAMETROPHYHUNT":
                  this.store.select(getActiveClassId()).pipe(take(1)).subscribe((response) => {
                    const url = this.router.serializeUrl(
                      this.router.createUrlTree(['/lehrer/schnitzeljagd/' + response])
                    );
                    window.open(url, '_blank');
                  })

                  break;
                case "SENDTEACHINGIDEA":
                  this.store.select(getActiveClassId()).pipe(take(1)).subscribe((response) => {
                    this.router.navigateByUrl("/lehrer/klasse/" + response + "/unterrichtsidee-einreichen").then((res) => {

                    });
                    // console.log(response);
                  })
                  break;
                default:
                  // alert("Dingnotgefunden_hää?? > " + link.linkValue);
              }
            }
          }
        })
      });


      if(quest.taskProgress === 100) {
        tags.push({
          id: "",
          title: "Bereits erledigt",
          beforeIcon: "check-circle",
        })
      } else {

        if(targetGroup === TargetGroup.TEACHER && quest.questTask.targetGroup === "SCHOLAR") {
          tags.push({
            id: "",
            title: "Durch die Schüler:innen zu erledigen",
            isClickable: false,
            beforeIcon: 'circle-infos'
          })
        }

        if(targetGroup === TargetGroup.STUDENT && quest.questTask.targetGroup === "TEACHER") {
          tags.push({
            id: "",
            title: "Durch die Lehrperson zu erledigen",
            isClickable: false,
            beforeIcon: 'circle-infos'
          })
        }

        if(quest.questTask.targetGroup === "TOGETHER"){
          tags.push({
            id: "",
            title: "Gemeinsam zu erledigen",
            isClickable: false,
            beforeIcon: 'circle-infos'
          })
        }

        if(quest.scoreType === 2){
            tags.push({
              id: "",
              title: `${quest.completePoints} von ${quest.totalPoints} Punkten`,
              isClickable: false,
              beforeIcon: 'circle-infos'
            })
        } else {
            tags.push({
              id: "",
              title: `${quest.completeEntries} von ${quest.totalEntries} erledigt`,
              isClickable: false,
              beforeIcon: 'circle-infos'
            })
        }
      }

      let isAvailable = true;

      if(quest.questTask.targetGroup === "TEACHER") {
        if(targetGroup === TargetGroup.STUDENT) {
          isAvailable = false;
        }
      }

      quests.push({
        title: quest.questTask?.taskTitle ?? "",
        tag: quest.questTask?.taskTag ?? "",
        description: quest.questTask?.taskDescription ?? "",
        trophyId: parseInt(quest.questTask?.iconNumber),
        tags,
        points: quest.questTask?.taskPoints ?? null,
        isAvailable: isAvailable,
        // isAvailable: false,
        state: quest.taskProgress === 100 ? QuestState.DONE : QuestState.IDLE
        // state: QuestState.DONE
      });

    })

    return quests;

  }

  openQuestsOverlayByRawData(data: any, targetGroup: TargetGroup): number {
    const quests: QuestListItem[] = this.backendQuestResponseToQuestItems(data, targetGroup);

    const overlayId = this.overlayService.openWindowOverlay({
      title: "Quest des Monats",
      componentMain: {
        component: QuestsListComponent,
        data: {
          items: quests,
          isPublic: targetGroup === TargetGroup.PUBLIC
        }
      },
      componentFooter: {
        component: AlertLargeFooterComponent,
        data: {
          text: "Schließen"
        }
      },
      theme: "quest"
    })

    return overlayId;
  }

  showQuestMessageIfNeeded(): void {


    this.data.getMonthQuestData().pipe(take(1)).subscribe((rawData) => {
      if(!rawData) return;

      const UNIQUE_ID = rawData.questTitle ?? "";
      let isAlreadyShown = false;

      if(window.localStorage.getItem(this._QUEST_MESSAGE_STORAGE_KEY)) {
        isAlreadyShown = window.localStorage.getItem(this._QUEST_MESSAGE_STORAGE_KEY) === UNIQUE_ID;
      }
      if(isAlreadyShown) return;

      this.largeMessageService.showLargeMessage({
        headline: "Quest des Monats<br/><em>" + rawData.questTitle + "</em>",
        text: rawData.descriptionText ?? undefined,
        primaryButtonLabel: "Mehr erfahren",
        primaryButtonCallback: () => {
           window.open('/gewinnspiel', '_blank');
        },
        secondaryButtonLabel: "Schließen",
        secondaryButtonCallback: () => {
          this.overlayService.removeLastComponent();
        },
        lottieLargeScale: false,
        lottiePath: this.interestFieldsService.getLottieSrcByInterestFieldId(rawData.iconNumber ?? 0),
        theme: LargeMessageTheme.GREEN,
        bigAnim: true,
        badgeSrc: "/assets/img/points-badge.svg"
      });

      window.localStorage.setItem(this._QUEST_MESSAGE_STORAGE_KEY, UNIQUE_ID);
    })
  }


  sendQuestDoneNotification(): void {
    this._onQuestDone.next();
  }

  onQuestDone(): Observable<void> {
    return this._onQuestDone;
  }

  showSuccessLargeMessageByQuestTaskId(id: number) {
    this.data.getMonthQuestData().pipe(take(1)).subscribe((response) => {
      const tasks = (response ? response.questTasks : null) ?? [];
      console.log(tasks);
      const foundTask = tasks.find((task: any) => parseInt(task.id) === id);

      if(foundTask) {
        console.log(foundTask);

        const iconPath = this.trophyRepositoryService.getTrophySuccessIconById(foundTask.iconNumber ?? 0);
        this.largeMessageService.showLargeMessage({
          headline: "Super, <em>" + foundTask.taskTitle + "</em> geschafft!",
          primaryButtonLabel: "Schließen",
          lottiePath: "/assets/placeholder.lottie",
          primaryButtonCallback: () => {
            this.overlayService.removeLastComponent();
          },
          textTitle: "Quest des Monats",
          text: "Meistere alle Quest des Monats Aufgaben um zusätzliche Punkte für euer Klassenkonto zu gewinnen!",
          mainIcon: iconPath,
          lottieLargeScale: true,
          theme: LargeMessageTheme.GOLD
        });
      } else {
        console.warn(`Got success message with payload ID ${id}, but it was not found in current month quest data`);
      }
    });
  }

  showLevelAchievedNotification(gameName: string = "GAME_NAME", categoryName: string = "CATEGORY_NAME", level: number = 2) {
    this.largeMessageService.showLargeMessage({
      headline: "<em>Neues Level!</em>" + gameName + " Kategorie " + categoryName,
      primaryButtonLabel: "Weiter",
      lottiePath: "/assets/placeholder.lottie",
      primaryButtonCallback: () => {
        this.overlayService.removeLastComponent();
      },
      text: "Gratuliere! Du hast das nächste Level in der Kategorie „" + categoryName + "” erreicht! Ab dieser Stufe sind noch maximal 60 Punkte pro Spiel möglich.",
      mainIcon: "/assets/img/new-level/" + level + ".png",
      lottieLargeScale: true,
      theme: LargeMessageTheme.BLUE
    });
  }
}
